export enum REACTIONS_COMMENTS {
    /**
     * @value Comments
     */
    COMMENTS = 'WIDGET_TYPE_COMMENTS',
    /**
     * @value %NB% comments. Comment
     */
    COMMENT_BUTTON_ARIA = 'FRONT.CONTENTS.COMMENT_BUTTON.ARIA',
    /**
     * @value {"one":"%NB% comment. Go to comment section","other":"%NB% comments. Go to comment section"}
     * @description Text read by the screen reader when focusing a comment button that redirect to another page.
     */
    COMMENT_BUTTON_LINK_ARIA_LABEL = 'REACTIONS.COMMENT_BUTTON_LINK_ARIA_LABEL',
    /**
     * @value Comment deleted
     * @description This label is displayed when a comment with replies is deleted, this stands as a placeholder.
     */
    COMMENT_DELETED = 'COMMENTS.COMMENT_DELETED',
    /**
     * @value Add a comment...
     * @description The placeholder of the comment editor.
     */
    COMMENT_EDITOR_PLACEHOLDER = 'FRONT.COMMENTS.COMMENT.EDITOR.PLACEHOLDER',
    /**
     * @value Delete comment
     * @description The title of the comment deletion confirm dialog
     */
    DELETE_COMMENT = 'COMMENTS.DELETE_CONFIRM_DIALOG_TITLE',
    /**
     * @value The comment will be deleted permanently. This action cannot be reverted.
     * @description The description of the comment deletion confirm dialog
     */
    DELETE_COMMENT_DESCRIPTION = 'COMMENTS.DELETE_CONFIRM_DIALOG_DESCRIPTION',
    /**
     * @value Edit
     */
    EDIT_COMMENT = 'COMMENT_EDIT',
    /**
     * @value Hides your comment for other users. The comment will still be visible for you and admins.
     *
     * This action can be reverted.
     * @description The body of the confirm dialog opening when clicking on the Hide button of a comment.
     */
    HIDE_THIS_COMMENT_DESCRIPTION = 'FRONT.COMMENTS.HIDE.CONFIRM_DIALOG.DESCRIPTION',
    /**
     * @value Highlight
     * @description The label of the highlight action button. To highlight a comment.
     */
    HIGHLIGHT = 'COMMENTS.HIGHLIGHT_COMMENT',
    /**
     * @value Highlighted comment
     * @description The title of the highlighted comment section.
     */
    HIGHLIGHTED_COMMENT_TITLE = 'COMMENTS.HIGHLIGHTED_COMMENT_TITLE',
    /**
     * @value Comment menu
     * @description Label set on the icon button for screen readers
     */
    MENU_ARIA_LABEL = 'FRONT.WIDGET.WIDGET_COMMENTS.MENU.ARIA_LABEL',
    /**
     * @value Mention notification available soon
     * @description Title for a warning message announcing that the notification on user mentioned in comments will be available soon.
     * A more complete explanation is provided by the key `COMMENTS.NOTIFICATION_AVAILABLE_SOON_DESCRIPTION`
     */
    NOTIFICATION_AVAILABLE_SOON = 'COMMENTS.NOTIFICATION_AVAILABLE_SOON',
    /**
     * @value Users mentioned here will not receive a notification on publish
     * @description Description for a warning message announcing that the notification on user mentioned in comments will be available soon.
     * The title of this message is provided by the key `COMMENTS.NOTIFICATION_AVAILABLE_SOON`
     */
    NOTIFICATION_AVAILABLE_SOON_DESCRIPTION = 'COMMENTS.NOTIFICATION_AVAILABLE_SOON_DESCRIPTION',
    /**
     * @value Display fewer replies
     */
    REPLIES_DISPLAY_LESS = 'FRONT.COMMENTS.REPLIES.DISPLAY_LESS',
    /**
     * @value {"one":"Display 1 more reply","other":"Display %NB% more replies"}
     */
    REPLIES_DISPLAY_MORE = 'FRONT.COMMENTS.REPLIES.DISPLAY_MORE',
    /**
     * @value Add a reply...
     * @description Reply editor placeholder.
     */
    REPLY_EDITOR_PLACEHOLDER = 'FRONT.COMMENTS.REPLY.EDITOR.PLACEHOLDER',
    /**
     * @value See original
     * @description The label of the button used to cancel the translation and show the original text, not translated.
     */
    SEE_ORIGINAL = 'FRONT.AUTO_TRANSLATION.SEE_ORIGINAL',
    /**
     * @value Translate into %LANG%
     * @description The label of the button to translate a content (can be a comment, post, or a page). Takes the target language as a variable.
     */
    TRANSLATE_ACTION = 'FRONT.AUTO_TRANSLATION.TRANSLATE_ACTION',
    /**
     * @value Translating in %LANG%...
     * @description The label to display when the translation is loading. Takes the target language as a variable.
     */
    TRANSLATION_LOADING = 'FRONT.AUTO_TRANSLATION.TRANSLATION_LOADING',
    /**
     * @value Translated in %LANG%
     * @description The label to display when the translation is displayed. Takes the target language as a variable.
     */
    TRANSLATION_SUCCESS = 'FRONT.AUTO_TRANSLATION.TRANSLATION_SUCCESS',
    /**
     * @value Unhighlight
     * @description The label of the unhighlight action button. To unhighlight a highlighted comment.
     */
    UNHIGHLIGHT = 'COMMENTS.UNHIGHLIGHT_COMMENT',
}
